import React from 'react';

import styles from './SkeletonComponents.module.scss';

/**
 * Web port of SkeletonComponents.jsx. Uses a plain CSS keyframe shimmer
 * (`shimmer-pulse`, defined in the module scss) — same mechanism as before,
 * just re-tuned sizes/radii to match the new card design (16px radius,
 * square image skeleton, clamp()-based fluid sizing). This uses plain
 * CSS-Modules `className={styles.x}` (not react-css-modules styleName),
 * matching how this file was already written.
 *
 * The LoadingBGImage + pulsing MiniLogo treatment lives in
 * CustomerCouponCard.jsx instead (it preloads the coupon's actual photo and
 * shows that animation only while that specific image is in flight) — so
 * this file stays as plain shimmer blocks for the initial page-load
 * skeletons, avoiding showing the same animated logo twice in a row.
 */
const ShimmerBlock = ({ className = '', style }) => <div className={`${styles.shimmer} ${className}`} style={style} />;

export const FollowedBusinessesSkeleton = () => (
  <div className={styles.hRow}>
    {[1, 2, 3, 4, 5, 6].map(i => (
      <ShimmerBlock key={i} className={styles.businessSkel} />
    ))}
  </div>
);

export const FavoritesSkeleton = () => (
  <div className={styles.hRow}>
    {[1, 2, 3].map(i => (
      <div key={i} className={styles.favSkelWrap}>
        <ShimmerBlock className={styles.favSkelImage} />
      </div>
    ))}
  </div>
);

export const NewestCouponsSkeleton = () => (
  <div className={styles.couponsGrid}>
    {[1, 2, 3].map(i => (
      <div key={i} className={styles.couponCardSkel}>
        <div className={styles.couponCardHeader}>
          <ShimmerBlock className={styles.couponLogoSkel} />
          <div className={styles.couponHeaderText}>
            <ShimmerBlock className={styles.couponNameSkel} />
            <ShimmerBlock className={styles.couponCitySkel} />
          </div>
        </div>
        <ShimmerBlock className={styles.couponImageSkel} />
        <div className={styles.couponFooter}>
          <ShimmerBlock className={styles.couponTitleSkel} />
          <ShimmerBlock className={styles.couponDescSkel} />
          <div className={styles.couponMetaRow}>
            <ShimmerBlock className={styles.couponMetaSkel} />
            <ShimmerBlock className={styles.couponMetaSkel} />
          </div>
        </div>
      </div>
    ))}
  </div>
);

export const CouponSkeleton = () => (
  <div className={styles.couponCardSkel}>
    <ShimmerBlock className={styles.couponImageSkel} />
    <div className={styles.couponFooter}>
      <ShimmerBlock className={styles.couponTitleSkel} />
      <ShimmerBlock className={styles.couponDescSkel} />
      <div className={styles.couponMetaRow}>
        <ShimmerBlock className={styles.couponMetaSkel} />
        <ShimmerBlock className={styles.couponMetaSkel} />
      </div>
    </div>
  </div>
);

export default ShimmerBlock;